import CustomSlider from '../../component/CustomSlider/CustomSlider'
import Icons from '../../constants/Icons'
import { useState, useEffect } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
const Home = () => {
  const [sliderImages, setSliderImages] = useState([])
  useEffect(() => {
    fetch('/PackageJson/Home/Images.json')

      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])


  console.log("sliderImages",sliderImages)
  return (
    <div className='min-home-section'>
      <CustomSlider />
      <SliderImages data={sliderImages} />
      <div className='whatsapp-icon'>
        <a
          style={{ color: '#fff' }}
          target='_blank'
          rel='noopener noreferrer'
          href='https://api.whatsapp.com/send?phone=918141429290'
        >
          <img src={Icons.BsWhatsapp} />
        </a>
      </div>
    </div>
  )
}
export default Home
